/**
 * Partner admins / partner team members use a non-tenant "home" company (typically public schema).
 * They must pick a child tenant company before using locations, assets, etc.
 */
export function isPartnerCompanySwitchEnabled(): boolean {
  // Default OFF: keep logic in place, but hide/disable UI unless explicitly enabled.
  return String(import.meta.env.VITE_ENABLE_PARTNER_COMPANY_SWITCH).toLowerCase() === "true";
}

export function isPartnerMultiTenantRole(role: string | undefined | null): boolean {
  const r = (role || "").toLowerCase();
  return r === "partner_admin" || r === "partner_team_member";
}

/** True when the user is a partner role and JWT context is still the shared/public home (not a tenant schema). */
export function shouldOpenPartnerCompanyPicker(user: {
  role?: string | null;
  schema?: string | null;
} | null): boolean {
  if (!isPartnerCompanySwitchEnabled()) return false;
  if (!user || !isPartnerMultiTenantRole(user.role)) return false;
  const s = (user.schema || "public").toLowerCase();
  return s === "public" || s === "";
}
